import React from "react";
import click from "../../utils/click";

const defaultProps = {
  height: "250px",
};

function InputImage({ value = [], onChange, saveImage }) {
  const [progress, setProgress] = React.useState({});
  const [images, setImages] = React.useState(value);

  function readImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImages((prevImages) => [...prevImages, e.target.result]);
    };
    reader.readAsDataURL(file);
  }

  function onFileSelected(files) {
    const newImages = [];
    for (const file of files) {
      readImage(file);
      newImages.push(file);
    }

    newImages.forEach((file) => {
      const options = {
        progress: (value) =>
          setProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: value * 100,
          })),
      };
      saveImage
        .execute(file, options)
        .then((result) => {
          setImages((prevImages) =>
            prevImages.map((img) => (img === file ? result.url : img))
          );
          setProgress((prevProgress) => {
            const { [file.name]: _, ...remainingProgress } = prevProgress;
            return remainingProgress;
          });

          onChange(result.url);
        })
        .catch((error) => {
          console.log("error", error);
        });
    });
  }

  function onClick() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.onchange = (e) => {
      const files = e.target.files;
      files && onFileSelected(files);
    };
    click(input);
  }

  return (
    <div>
      <div
        onClick={onClick}
        className="rounded d-flex position-relative cursor-pointer bg-light"
        style={{
          height: "12rem",
          width: "12rem",
          border: "1px dashed rgba(253, 181, 21, .5)",
          marginBottom: "1rem",
        }}
      >
        {Object.keys(progress).length > 0 && (
          <div className="position-absolute h-100 w-100 bg-black bg-opacity-25" />
        )}
        {Object.keys(progress).length > 0 && (
          <div className="position-absolute h-100 w-100 d-flex">
            <h3 className="m-auto text-white">
              {Math.max(...Object.values(progress)).toFixed(0)}%
            </h3>
          </div>
        )}
        <div className="position-absolute h-100 w-100 d-flex justify-content-center p-2 ">
          {!images.length ? (
            <div className="d-flex flex-column justify-content-center align-items-center text-primary">
              <i className="bi bi-image opacity-50 h3 text-secondary"></i>
              <p
                className="p-0 m-0 fw-semibold text-primary"
                style={{ fontSize: ".7rem" }}
              >
                Upload Image
              </p>
              <p className="p-0 m-0 text-primary" style={{ fontSize: ".5rem" }}>
                No Image Uploaded
              </p>
            </div>
          ) : (
            <div className="d-flex flex-wrap align-items-center h-100 gap-2 justify-content-center">
              {images.slice(0, 8).map((img, index) => (
                <div
                  key={index}
                  className="rounded"
                  style={{
                    height: "3rem",
                    width: "3rem",
                    position: "relative",
                    overflow: "hidden",
                    border: "1px solid rgba(253, 181, 21, .5)",
                  }}
                >
                  <img
                    src={img}
                    alt={`Image ${index}`}
                    className="img-fluid"
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </div>
              ))}
              {images.length > 8 && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "3rem",
                    width: "3rem",
                    position: "relative",
                    border: "1px solid rgba(253, 181, 21, .5)",
                  }}
                >
                  <span className="text-primary fw-bold">
                    +{images.length - 8}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

InputImage.defaultProps = defaultProps;
export default InputImage;
